// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"9a52efa6","160":"52557f9f","208":"a8a4506a","293":"4375ae8c","453":"becee71d","516":"e2f363bf","519":"1e6cecac","917":"c77a2c33","946":"0f1fa4ad"}[chunkId] + ".chunk.js";
};